/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ItRequisitionTypeCodes } from '@Enum/api/ItRequisitionTypeCodes.enum';
import * as Yup from 'yup';

const contactNoValidator = Yup.string()
  .required("Kindly enter the employee's Contact Number!")
  .max(10, 'Kindly enter the number no more than 10 digits');

const newSimCardSchema = Yup.object().shape({
  simCardCreditLimit: Yup.number().nullable().required('Please choose'),
  contactNo: contactNoValidator,
});

const getEmailSchema = (isFileAttached: boolean) =>
  Yup.object().shape({
    emailIdLeft: Yup.string()
      .nullable()
      .required('Kindly choose the email ID First and Last name!')
      .test(
        'Validate values are different',
        'Both email ID can not be same! Kindly choose different!',
        (value, context) => {
          return context.parent.emailIdRight !== value;
        }
      ),
    emailIdRight: Yup.string()
      .nullable()
      .required('Kindly choose the email ID First and Last name!')
      .test(
        'Validate values are different',
        'Both email ID can not be same! Kindly choose different!',
        (value, context) => {
          return context.parent.emailIdLeft !== value;
        }
      ),
    emailSignatureLeft: Yup.string()
      .nullable()
      .required('Kindly choose the email signature name!')
      .test(
        'Validate values are different',
        'Both email signature name can not be same! Kindly choose different!',
        (value, context) => {
          return context.parent.emailSignatureRight !== value;
        }
      ),
    emailSignatureRight: Yup.string()
      .nullable()
      .required('Kindly choose the email signature name!')
      .test(
        'Validate values are different',
        'Both email signature name can not be same! Kindly choose different!',
        (value, context) => {
          return context.parent.emailSignatureLeft !== value;
        }
      ),
    document: Yup.string()
      .nullable()
      .test('check that file is attached', 'Please attach document', () => {
        return isFileAttached;
      }),
    contactNo: contactNoValidator,
  });

const buildSmartAccessSchema = Yup.object().shape({
  isNewUser: Yup.number()
    .nullable()
    .required('Kindly select the user information!'),
  module: Yup.array().test(
    'Validate field is not empty',
    'Kindly select any module!',
    (value) => {
      const isFilledArray = Array.isArray(value) && value.length > 0;
      return isFilledArray;
    }
  ),
  organization: Yup.string().required('Kindly select any organization!'),
  projects: Yup.array().min(1, 'Kindly select any project!'),
  requiredRole: Yup.number().nullable(),
  contactNo: contactNoValidator,
});

const accessoriesSchema = Yup.object().shape({
  accessories: Yup.array().min(1, 'Kindly select any accessory!'),
  contactNo: contactNoValidator,
});

const intCallsSchema = Yup.object().shape({
  intCallsNumber: Yup.string()
    .nullable()
    .test(
      'check that intCallsNumber is filled number',
      'Kindly enter the international number!',
      (value) => {
        return value !== null && Number.isFinite(Number(value));
      }
    ),
  countryCode: Yup.string()
    .nullable()
    .min(1, 'Country Code must be at least 1 character')
    .test(
      'check that country code is filled number',
      'Kindly enter the international number!',
      (value) => {
        return value !== null && Number.isFinite(Number(value));
      }
    ),
});

const assetStatusChangeSchema = Yup.object().shape({
  contactNo: contactNoValidator,
});

const lostSimCardSchema = Yup.object().shape({
  contactNo: contactNoValidator,
});

const simAddonSchema = Yup.object().shape({
  contactNo: contactNoValidator,
});

export const getItRequisitionFormSchema = (
  itReqType: number | null,
  isFileAttached: boolean
) => {
  const baseSchema = Yup.object().shape({
    itReqType: Yup.number().nullable().required('Please choose request type'),
    remarks: Yup.string().required('Kindly enter remarks!'),
  });

  if (itReqType === ItRequisitionTypeCodes.NEW_SIM_CARD) {
    const schema = baseSchema.concat(newSimCardSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.EMAIL) {
    const emailSchema = getEmailSchema(isFileAttached);
    const schema = baseSchema.concat(emailSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.BUILD_SMART_ACCESS) {
    const schema = baseSchema.concat(buildSmartAccessSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.ACCESSORIES) {
    const schema = baseSchema.concat(accessoriesSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.INTERNATIONAL_CALLS) {
    const schema = baseSchema.concat(intCallsSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.ASSET_STATUS_CHANGE) {
    const schema = baseSchema.concat(assetStatusChangeSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.LOST_SIM_CARD) {
    const schema = baseSchema.concat(lostSimCardSchema);
    return schema;
  }

  if (itReqType === ItRequisitionTypeCodes.SIM_ADDON_REQUEST) {
    const schema = baseSchema.concat(simAddonSchema);
    return schema;
  }

  return baseSchema;
};
